import { startTransition, useActionState, useState } from "react";
import { useTranslation } from "react-i18next";
import ContactTemplates from "../../contact-templates";
import { toaster } from "@/utils/toaster";
import { Button } from "@/components/ui/button";
import { useTemplates } from "../use-template-promise";
import { type PanelProps } from "../types";

export function SmsPanel({ patient, onClose }: PanelProps) {
  const { t } = useTranslation();
  const [selectedTemp, setSelectedTemp] = useState("");

  const { templates, isLoading } = useTemplates(
    `/api/VisitOnline/SmsOnlinVisit?type=showlist&vid=${patient.pid}&time=${patient.visitTime}&pending=${patient.isPending}&sendtype=sms`
  );

  const [, sendAction, isSending] = useActionState(async () => {
    if (!selectedTemp || !patient.pid) {
      toaster("error", t("error"), {
        description: t("please_select_patient"),
        closeButton: true,
      });
      return null;
    }
    try {
      const res = await fetch(
        `/api/VisitOnline/SmsOnlinVisit?type=send_sms&vid=${patient.pid}&smsid=${selectedTemp}&pending=${patient.isPending}&sendtype=sms`
      );
      if (res.status === 200) {
        toaster("success", t("message_sent_success"), { closeButton: true });
        onClose();
      } else {
        toaster("error", t("error_occurred"), { closeButton: true });
      }
    } catch (error) {
      console.error("Send error:", error);
      toaster("error", t("error_occurred"), { closeButton: true });
    }
    return null;
  }, null);

  return (
    <div className="flex flex-col min-h-0 gap-4">
      <ContactTemplates
        isLoading={isLoading}
        templates={templates}
        callBack={setSelectedTemp}
      />
      <div className="flex gap-2 w-full shrink-0">
        <Button variant="outline" className="min-w-28" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button
          disabled={isSending}
          className="flex-1"
          onClick={() => startTransition(() => sendAction())}
        >
          {isSending ? "..." : t("send")}
        </Button>
      </div>
    </div>
  );
}
